import React from 'react';
import { useTranslation } from 'react-i18next';

import SignUpMetadata from 'components/Identification/Signup/SignUpMetadata';
import SignUp from 'components/Identification/Signup/SignUp';
import useGtmPageView from 'hooks/gtm/useGtmPageView';
import { GTM_PAGE_OTHER } from 'settings/gtm/gtmPageView';

import styles from './page.module.scss';

export default function CreatePage(): JSX.Element {
  const { t } = useTranslation(['signUpPage']);

  useGtmPageView(GTM_PAGE_OTHER, '');

  return (
    <>
      <SignUpMetadata />
      <div>
        <h1 className={styles.title}>{t('SIGNUP_TITLE_PAGE')}</h1>
      </div>
      <SignUp classes={{ container: styles.pageContainer }} />
    </>
  );
}
